// @ts-check
import { useCachedDirectory } from '~/other/directoryUtils';

const filter = (users) => users.filter(user => user.role !== 'viewer')

export function useTasksDirectory() {
    return useCachedDirectory(filter);
}